import { useState, useEffect, useCallback } from 'react';
import { useApi } from './useApi';
import type { AccountTrigger } from '../types';

interface UseTriggers {
  triggers: AccountTrigger[];
  loading: boolean;
  error: string;
  refresh: () => Promise<void>;
}

export function useTriggers(accountId: string | undefined, orgId: string | undefined): UseTriggers {
  const { apiGet } = useApi();
  const [triggers, setTriggers] = useState<AccountTrigger[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const load = useCallback(async () => {
    if (!accountId || !orgId) {
      setTriggers([]);
      setLoading(false);
      return;
    }
    setLoading(true);
    setError('');
    try {
      const { triggers: data } = await apiGet<{ triggers: AccountTrigger[] }>(
        `/v1/account/${accountId}/triggers?org_id=${encodeURIComponent(orgId)}`,
      );
      setTriggers(data || []);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to load triggers');
    }
    setLoading(false);
  }, [accountId, apiGet, orgId]);

  useEffect(() => {
    load();
  }, [load]);

  return { triggers, loading, error, refresh: load };
}
